// src/TermsOfUse.js
import React from 'react';
import './TermsOfUse.css';
import { BM_DISCLAIMER, BM_DISCLAIMER_EXTRA } from './legal';

const TermsOfUse = () => {
  return (
    <div className="terms-of-use">
      <h1>Terms of Use</h1>
      <p><strong>Last updated: June 7, 2026</strong></p>

      <p><em><b>{BM_DISCLAIMER} {BM_DISCLAIMER_EXTRA}</b></em></p>

      <p>These Terms of Use ("Terms") govern your use of Naviguesser ("we," "us," or "our") — our website and our phone and watch apps. By using any of them, you agree to these Terms.</p>

      <h2>1. What Naviguesser is</h2>
      <p>Naviguesser helps you find, rate, and navigate to events and art at Burning Man. The same account and data work across our website, phone app, and watch app. We show information from the Burning Man events schedule, which we do not own or control, so we cannot guarantee it is accurate, reliable, or complete.</p>

      <h2>2. Who can use it</h2>
      <p>Naviguesser is for adults attending an adults-only event. You must be old enough to form a binding agreement where you live, and in any case you may not use Naviguesser if you are under 13.</p>

      <h2>3. Your account</h2>
      <p>You are responsible for keeping your sign-in secure and for activity on your account. Please keep your information accurate. You can stop using Naviguesser and ask us to delete your account at any time through the feedback form.</p>

      <h2>4. How you may use the service</h2>
      <p>Use Naviguesser for your own personal, non-commercial purposes. You must not:</p>
      <ul>
        <li>Break any laws or regulations.</li>
        <li>Infringe anyone else's rights.</li>
        <li>Disrupt or interfere with the service or try to access it in unauthorized ways.</li>
      </ul>

      <h2>5. Your content</h2>
      <p>You keep ownership of what you submit — your votes, ratings, picks, and feedback. By submitting it, you give us permission to store and use it to run and improve the service, including the right to share combined, anonymous statistics that do not identify you. If you send us feedback or suggestions, we may use them freely to improve Naviguesser.</p>

      <h2>6. Event content and copyright</h2>
      <p>Event and art listings come from the Burning Man schedule and belong to their respective owners. You may not reuse, reproduce, or redistribute that content for commercial purposes without permission. If you believe content on Naviguesser infringes your copyright, contact us through the feedback form and we will review it.</p>

      <h2>7. Our intellectual property</h2>
      <p>Naviguesser — including the apps, the name, and the design — belongs to us. We grant you a limited, personal, revocable, non-transferable license to use the service under these Terms. You may not copy, modify, or distribute our software or branding without permission.</p>

      <h2>8. Third-party services</h2>
      <p>Naviguesser runs on Google services (Firebase for storage and sign-in, and Google Forms for feedback). Your use of those parts is also subject to Google's terms.</p>

      <h2>9. Warranties and disclaimers</h2>
      <p>Naviguesser is provided on an "as-is" and "as-available" basis, without warranties of any kind, whether express or implied, including implied warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that the service will be uninterrupted, secure, or error-free. Do not rely on it as your only means of navigation in a remote environment.</p>

      <h2>10. Limitation of liability</h2>
      <p>To the maximum extent permitted by law, we will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits, revenue, data, or goodwill, resulting from:</p>
      <ul>
        <li>Your access to, use of, or inability to use the service.</li>
        <li>Any conduct or content of any third party on the service.</li>
        <li>Any content obtained from the service.</li>
      </ul>

      <h2>11. Indemnification</h2>
      <p>You agree to cover us for any claims, losses, or costs that arise from your misuse of the service or your breach of these Terms.</p>

      <h2>12. Termination</h2>
      <p>You can stop using Naviguesser at any time and ask us to delete your account. We may suspend or end your access if you break these Terms or if we need to for legal or operational reasons. Sections that should reasonably survive — such as content licenses, disclaimers, limitation of liability, and indemnification — continue to apply after termination.</p>

      <h2>13. Changes to these Terms</h2>
      <p>We may update these Terms from time to time. We will post the new version on this page and update the date at the top. If you keep using Naviguesser after a change, you accept the updated Terms.</p>

      <h2>14. Governing law</h2>
      <p>These Terms are governed by the laws of the State of California, USA, without regard to its conflict-of-law rules.</p>

      <h2>15. General</h2>
      <p>If any part of these Terms is found unenforceable, the rest still applies. These Terms are the entire agreement between you and us about the service. You may not transfer your rights under these Terms; we may transfer ours. If we do not enforce a part of these Terms right away, that is not a waiver of our right to do so later.</p>

      <h2>16. Contact us</h2>
      <p>If you have any questions about these Terms, use the feedback form available on our service.</p>
    </div>
  );
};

export default TermsOfUse;
